/* Printtex : mesure de l'outil de personnalisation et du devis.
   Publie des événements Shopify personnalisés (Shopify.analytics.publish), relayés vers Google Analytics
   par le pixel personnalisé « Printtex mesure » (Paramètres > Événements clients).
   Fichier séparé de l'outil : écoute seulement les clics, ne modifie rien. */
(() => {
  const produit = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  const envoyer = (nom, extra) => {
    try { window.Shopify?.analytics?.publish?.(nom, { produit, page: location.pathname, ...extra }); } catch (e) { /* mesure seulement */ }
  };
  const dejaEnvoye = new Set();
  const uneFois = (nom) => { if (!dejaEnvoye.has(nom)) { dejaEnvoye.add(nom); envoyer(nom); } };

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-pp-open], [data-pp-add-text], [data-pp-add]');
    if (!t) return;
    if (t.matches('[data-pp-open]')) envoyer('perso_ouvert');
    else if (t.matches('[data-pp-add-text]')) uneFois('perso_texte');
    else if (t.matches('[data-pp-add]') && !t.disabled) envoyer('perso_ajout_panier');
  }, true);

  document.addEventListener('change', (e) => {
    if (e.target.matches?.('[data-pp-file]') && e.target.files?.length) uneFois('perso_image');
    if (e.target.matches?.('[data-pd-logo]') && e.target.files?.length) uneFois('devis_logo');
  }, true);

  document.addEventListener('submit', (e) => {
    if (e.target.closest?.('#devis') && e.target.checkValidity()) uneFois('devis_envoye');
  }, true);
})();
